export class PageEvent {
  constructor(
    public pageIndex: number,
    public pageSize: number,
    public length: number,
    public previousPageIndex: number = 0
  ) {}
}
